/** Shared positions (percent of stage) for the relay lanterns. */
export const RELAYS = [
  { x: 15, y: 26 },
  { x: 85, y: 24 },
  { x: 10, y: 70 },
  { x: 90, y: 72 },
  { x: 50, y: 12 },
] as const;

/** Where the note rests before it drifts. */
export const NOTE_ORIGIN = { x: 50, y: 48 } as const;
